<template>
  <div class="second-tag-wrap">
    <div class="second-tag-filter">
      <el-select
        clearable
        @change="successCallBack"
        style="margin-right: 16px"
        v-model="formSearch.firstTagIds"
        filterable
        multiple
        collapse-tags
        class="filter-item all-select"
        placeholder="请选择一级标签"
        popper-class="BI-select BI-select-product"
      >
        <el-option v-for="item in tagOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select
        clearable
        @change="successCallBack"
        style="margin-right: 16px"
        v-model="formSearch.secondTagIds"
        filterable
        multiple
        collapse-tags
        class="filter-item all-select"
        placeholder="请选择二级标签"
        popper-class="BI-select BI-select-product"
      >
        <el-option v-for="item in secondTagOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select
        clearable
        @change="successCallBack"
        style="margin-right: 16px"
        v-model="formSearch.thirdTagIds"
        filterable
        multiple
        collapse-tags
        class="filter-item all-select"
        placeholder="请选择三级标签"
        popper-class="BI-select BI-select-product"
      >
        <el-option v-for="item in thirdTagOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select
        clearable
        @change="successCallBack"
        v-model="formSearch.operators"
        filterable
        multiple
        collapse-tags
        class="filter-item all-select"
        placeholder="请选择编辑人"
        popper-class="BI-select BI-select-product"
      >
        <el-option v-for="item in operatorsOptions" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <el-button @click="addTag">新建标签</el-button>
      <el-button @click="downloadTemplate" style="margin-right: 16px">下载模板</el-button>
      <el-upload
        class="upload-demo"
        action=""
        :auto-upload="false"
        :show-file-list="false"
        :on-change="uploadExcel"
        :file-list="fileList"
        :multiple="false"
        :limit="1"
      >
        <el-button size="small" type="primary" :loading="downloadLoading">导入标签</el-button>
        <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
      </el-upload>
    </div>

    <div class="table">
      <el-table id="rebateSetTable" v-loading="loading" :data="tableData" style="width: 100%" height="100%">
        <el-table-column v-for="item of thirdColumns" :label="item.label" :key="item.prop" :prop="item.prop" :width="item.width">
          <template slot-scope="scope">
            <div v-if="item.prop === 'operate'">
              <el-button type="text" @click="editTag(scope.row)">编辑</el-button>
              <el-button type="text" @click="deleteTag(scope.row)">删除</el-button>
            </div>
            <span v-else> {{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <self-pagination
        :total="pageData.total"
        :pageSize="pageData.size"
        :currentPage="pageData.page"
        ref="tabelPagination"
        @getCurrentPage="changePage"
        @handleSizeChange="changePageSize"
      ></self-pagination>
    </div>
    <add-tag-modal ref="addModal" :tagOptions="tagOptions" @successCallBack="successCallBack"></add-tag-modal>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="30%">
      <div class="error-title">表格部分数据由于存在错误而导入失败（如下）:</div>
      <div class="error" v-for="(item, index) in errList" :key="index">
        {{ item }}
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { thirdColumns } from "../config";
import AddTagModal from "./AddTagModal.vue";
import { getTagList, delTag, getSelectTagList } from "@/api/property.js";
import axios from "axios";
export default {
  components: {
    AddTagModal,
  },
  props: {
    tagOptions: Array,
    operatorsOptions: Array,
  },

  data() {
    return {
      formSearch: {
        firstTagIds: [],
        secondTagIds: [],
        thirdTagIds: [],
        operators: [],
      },
      dialogVisible: false,
      errList: [],
      secondTagOptions: [],
      thirdTagOptions: [],
      thirdColumns,
      tableData: [],
      loading: false,
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      downloadLoading: false,
      fileList: [], //上传的文件列表
    };
  },

  computed: {},

  watch: {
    "formSearch.firstTagIds": {
      handler(val, oldval) {
        // 判断是否新增选择
        if (val?.length < oldval?.length || oldval?.length === 0) {
          this.formSearch.secondTagIds = [];
          this.formSearch.thirdTagIds = [];
          if (this.formSearch.secondTagIds?.length === 0) {
            this.getThirdOptions();
          }
        }
        this.getSecondOptions();
      },
      deep: true,
      immediate: true,
    },
    "formSearch.secondTagIds": {
      handler(val, oldval) {
        // 判断是否新增选择
        if (val?.length < oldval?.length || oldval?.length === 0) {
          this.formSearch.thirdTagIds = [];
        }
        this.getThirdOptions();
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.getList();
  },

  methods: {
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getList();
    },
    getSecondOptions() {
      getSelectTagList({ dataLevel: 2, firstTagIds: this.formSearch.firstTagIds?.join(",") }).then((res) => {
        this.secondTagOptions = res.data;
      });
    },
    getThirdOptions() {
      getSelectTagList({
        dataLevel: 3,
        firstTagIds: this.formSearch.firstTagIds?.join(","),
        secondTagIds: this.formSearch.secondTagIds?.join(","),
      }).then((res) => {
        this.thirdTagOptions = res.data;
      });
    },
    getList() {
      getTagList({
        pageSize: this.pageData.size,
        page: this.pageData.page,
        dataLevel: 3,
        operators: this.formSearch.operators.join(","),
        firstTagIds: this.formSearch.firstTagIds.join(","),
        secondTagIds: this.formSearch.secondTagIds.join(","),
        thirdTagIds: this.formSearch.thirdTagIds.join(","),
      }).then((res) => {
        this.tableData = res.data.list;
        this.pageData.total = res.data.total;
      });
    },
    addTag() {
      this.$refs.addModal.openModal("third", "add");
    },
    editTag(data) {
      this.$refs.addModal.openModal("third", "edit", data);
    },
    deleteTag(record) {
      this.$confirm("确定删除该标签?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delTag({ id: record.id }).then((res) => {
            if (res.code == "0000") {
              this.$message.success("删除成功");
              this.successCallBack();
            }
          });
        })
        .catch(() => {});
    },
    successCallBack() {
      this.pageData.page = 1;
      this.getList();
      this.getThirdOptions();
    },
    downloadTemplate() {
      let downUrl = process.env.VUE_APP_DOWNLOAD_PAGE + `/${process.env.VUE_APP_CONTENT_PATH}/tag/downloadTemplate`;
      window.open(downUrl, "_self");
    },
    //文件校验方法
    beforeExcelUpload(file) {
      // 通过split方法和fileArr方法获取到文件的后缀名
      let fileArr = file.name.split(".");
      let suffix = fileArr[fileArr.length - 1];
      //只能导入.xls和.xlsx文件
      if (!/(xlsx)/i.test(suffix)) {
        this.$message("文件格式不正确,只支持xlsx格式");
        return false;
      }
      // //不能导入大小超过2Mb的文件
      // if (file.size > 2 * 1024 * 1024) {
      //   this.$message('文件过大，请上传小于2MB的文件〜')
      //   return false
      // }
      return true;
    },
    uploadExcel(file) {
      //判断是否符合beforeExcelUpload方法中的条件
      if (this.beforeExcelUpload(file)) {
        this.downloadLoading = true;
        this.fileList.name = file.name;
        this.fileList.url = "";
        const formdata = new FormData();
        formdata.append("file", file.raw);
        axios({
          method: "POST",
          url: `/${process.env.VUE_APP_CONTENT_PATH}/tag/uploadTag`,
          data: formdata,
          baseURL: process.env.VUE_APP_BASE_URL,
          headers: {
            "Content-Type": "multipart/form-data; ",
          },
        })
          .then((res) => {
            if (res.data.code === "0000") {
              this.downloadLoading = false;
              this.fileList = [];
              this.successCallBack();
              this.$emit("exportSuccess");
              this.getSecondOptions();
              if (res.data.data?.length > 0) {
                this.errList = res.data.data;
                this.dialogVisible = true;
              } else {
                this.$message.success("导入成功");
              }
            }
          })
          .catch(() => {
            this.downloadLoading = false;
            this.fileList = [];
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.second-tag-wrap {
  height: 100%;
  .second-tag-filter {
    display: flex;
    .filter-item {
      margin-right: 16px;
      /deep/ .el-input__inner {
        height: 32px !important;
      }
    }
  }
  .table {
    height: calc(100% - 135px);
    margin-top: 20px;
  }
  .error-title {
    color: black;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 12px;
  }
  .error {
    margin-top: 4px;
  }
}
</style>
